import type { HostBridge, HostBridgeMessage } from "./hostBridge";

function canPostMessage(): boolean {
  return typeof window !== "undefined" && typeof window.postMessage === "function";
}

function postMessage(message: HostBridgeMessage): boolean {
  if (!canPostMessage()) {
    return false;
  }

  window.parent.postMessage(message, "*");
  return true;
}

export const windowHostBridge: HostBridge = {
  postMessage,
  sendBack() {
    return postMessage({
      type: "LoggedOut",
      data: {
        action: "back",
      },
    });
  },
  sendRecharge() {
    return postMessage({
      type: "TurnShop",
      data: {},
    });
  },
  sendLogin() {
    return postMessage({
      type: "SDKLogin",
      data: {},
    });
  },
  sendTokenExpired(message, title) {
    return postMessage({
      type: "LoggedOut",
      data: {
        action: "tokenExpired",
        ...(message ? { message } : {}),
        ...(title ? { title } : {}),
      },
    });
  },
  sendCurrencyChange(currency) {
    return postMessage({
      type: "MoneyType",
      data: [currency === "gc" ? 1 : 0],
    });
  },
  sendGetWallet() {
    return postMessage({
      type: "GetWallet",
      data: {},
    });
  },
  sendNavigate(url) {
    return postMessage({
      type: "BetbyNavigate",
      data: { url },
    });
  },
  sendUrlChange(url) {
    return postMessage({
      type: "BetbyUrlChange",
      data: { url },
    });
  },
};
